<app-ok-dialog
  *ngIf="houseIsNotOccupiedSelected && socialSelected && !socialOtherSelected; else lessorDialog"
  [message]="'lessorInformations.houseIsOccupiedRequired' | translate"
  [okLabel]="'lessorInformations.okUnderstand' | translate"
  (closeDialogEvent)="houseIsNotOccupiedSelected = false">
</app-ok-dialog>

<ng-template #lessorDialog>
  <p-dialog
    [(visible)]="visible"
    [modal]="true"
    [resizable]="false"
    [closable]="false"
    [closeOnEscape]="true"
    [draggable]="false"
    (onShow)="onShow()"
    (onHide)="onHide()"
    class="font-app-regular">
    <ng-template pTemplate="header">
      <div class="header-name ml-auto mr-auto p-4 bg-lightest rounded-md w-full">
        <h1 class="white-space-nowrap text-xl flex justify-center font-app-bold text-darkest">
          {{ "lessorInformations.sendLessorAttestationPopupTitle" | translate }}
        </h1>
      </div>
    </ng-template>

    <section class="flex flex-row items-start py-8">
      <form
        [formGroup]="formGroup"
        class="grid grid-cols-[220px_400px] grid-flow-row auto-rows-min items-center gap-x-4 gap-y-4">
        <label
          for="lessorType"
          class="font-app-bold"
          >{{ "lessorInformations.lessorType" | translate }} :</label
        >
        <div class="flex flex-col w-full md:grid md:gap-x-4 md:grid-cols-2 items-center">
          <button
            type="button"
            [label]="'optionalValues.social' | translate"
            pButton
            class="bg-white border-solid border-[1px] w-full p-1 mr-3"
            (click)="onSocialSelected()"
            [ngClass]="setClassActive(socialSelected)"></button>

          <button
            type="button"
            [label]="'optionalValues.private' | translate"
            pButton
            class="bg-white border-solid border-[1px] w-full p-1 mr-3"
            (click)="onPrivateSelected()"
            [ngClass]="setClassActive(privateSelected)"></button>
        </div>

        <label
          *ngIf="socialSelected"
          for="lessorName"
          class="font-app-bold"
          >{{ "lessorInformations.lessorName" | translate }} :</label
        >

        <p-dropdown
          *ngIf="socialSelected"
          formControlName="lessorName"
          inputId="lessorName"
          [options]="lessorList"
          optionLabel="name"
          appendTo="body"
          (onChange)="onLessorSelected($event)"
          styleClass="h-[34px] items-center border-solid border-[1px] rounded border-light shadow"
          [placeholder]="'lessorInformations.lessorName' | translate" />

        <label
          *ngIf="socialSelected && !isLessorNameOther"
          for="lessorType"
          class="font-app-bold"
          >{{ "lessorInformations.houseIsOccupied" | translate }} :</label
        >
        <div
          *ngIf="socialSelected && !isLessorNameOther"
          class="flex flex-col w-full md:grid md:gap-x-4 md:grid-cols-2 items-center">
          <button
            type="button"
            [label]="'lessorInformations.yes' | translate"
            pButton
            class="bg-white border-solid border-[1px] w-full p-1 mr-3"
            (click)="onOccupiedSelected()"
            [ngClass]="setClassActive(houseIsOccupiedSelected)"></button>

          <button
            type="button"
            [label]="'lessorInformations.no' | translate"
            pButton
            class="bg-white border-solid border-[1px] w-full p-1 mr-3"
            (click)="onNotOccupiedSelected()"
            [ngClass]="setClassActive(houseIsNotOccupiedSelected)"></button>
        </div>

        <label
          *ngIf="socialSelected && !isLessorNameOther"
          for="reference1"
          class="font-app-bold"
          >{{ reference1Title }} :</label
        >
        <input
          *ngIf="socialSelected && !isLessorNameOther"
          type="text"
          pInputText
          [disabled]="true"
          inputId="reference1"
          formControlName="lessorReference1"
          styleClass="border rounded w-full py-2 px-3 text-black" />

        <label
          *ngIf="socialSelected && !isLessorNameOther"
          for="reference2"
          class="font-app-bold"
          >{{ reference2Title }} :</label
        >
        <input
          *ngIf="socialSelected && !isLessorNameOther"
          type="text"
          pInputText
          [disabled]="true"
          inputId="reference2"
          formControlName="lessorReference2"
          styleClass="border rounded w-full py-2 px-3 text-black" />

        <label
          *ngIf="socialSelected && isLessorNameOther"
          for="lessorManualName"
          class="font-app-bold"
          >{{ "lessorInformations.lessorName" | translate }} :</label
        >
        <input
          *ngIf="socialSelected && isLessorNameOther"
          type="text"
          pInputText
          [disabled]="true"
          inputId="lessorManualName"
          formControlName="lessorManualName"
          styleClass="border rounded w-full py-2 px-3 text-black" />

        <label
          *ngIf="privateSelected || isLessorNameOther"
          for="lessorEmail"
          class="font-app-bold"
          >{{ "lessorInformations.lessorEmail" | translate }} :</label
        >
        <input
          *ngIf="privateSelected || isLessorNameOther"
          type="text"
          pInputText
          [disabled]="true"
          inputId="lessorEmail"
          formControlName="lessorEmail"
          styleClass="border rounded w-full py-2 px-3 text-black" />

        <div class="col-span-full flex flex-row text-sm text-medium_light mt-2">
          <p *ngIf="privateSelected">
            {{ "lessorInformations.privateLessorSelectedInformation" | translate }}
          </p>
        </div>
      </form>
    </section>

    <section class="col-span-full flex flex-row">
      <button
        pButton
        type="button"
        label="Annuler"
        class="bg-white border-primary border-solid border-[1px] w-full p-2 mr-3 text-primary"
        (click)="cancel()"></button>
      <button
        pButton
        type="button"
        label="Valider"
        class="bg-primary text-white w-full p-2"
        [disabled]="
          !formGroup.valid || houseIsNotOccupiedSelected || (!houseIsNotOccupiedSelected && !houseIsOccupiedSelected)
        "
        (click)="validate()"></button>
    </section>
  </p-dialog>
</ng-template>

